import { createRouter } from '@tanstack/react-router'
import { ENV_VITE_BASE_PATH } from './env.ts'
import { routeTree } from './routeTree.gen'

export const router = createRouter({
  // Always match vite base path.
  basepath: ENV_VITE_BASE_PATH,
  routeTree,
  defaultPreload: 'intent',
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
